import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../toster-notification/NotificationContext";
import { authService } from "../../services/authService";
import { validateEmail } from "../../utils/validators";
import Loader from "../shared/Loader";

import { SecurityIcon } from "../../assets/icons";

const ForgotPasswordPage: React.FC = () => {

    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const { notify } = useNotification();

    const handleSandEmail = async () => {
        setLoading(true);

        setEmailError(validateEmail(email));

        if (emailError) {
            return;
        }

        try {
            const respose = await authService.forgotPassword({ email });

            if (respose.success) {
                notify("success", respose.message);
                navigate("/login");
            }

        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else{
                notify("error", "An error occurred. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="forgot-password-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="forgot-password-wrapper">
                    <div className="form-block-6 w-form">
                        <div className="small-box-div">
                            <img src={SecurityIcon} loading="lazy" alt="" className="icon-size-28" />
                        </div>
                        <div className="div-block-28">
                            <div className="_2rem bold text-center">Forgot your password?</div>
                            <div className="description-text text-center">A code will be sent to your email to help reset password</div>
                        </div>
                        <form className="form-7">
                            <div className="form-input-box">
                                <label className="label-input">Email Adress</label>
                                <input className="form-input w-input" type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)} />

                                {emailError && <div className="error-text">{emailError}</div>}
                            </div>

                            {loading ?
                                <Loader fullscreen={false} />
                                :
                                <div className="button-primary" onClick={handleSandEmail} >
                                    <div>Reset password</div>
                                </div>
                            }

                        </form>

                        <div className="link-text grey" onClick={() => navigate("/login")}>Back to login</div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default ForgotPasswordPage;